import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { DionEnvServiceWrapper } from '@dion-web/env-service';

import { ThemeProvider as DionThemeProvider } from '@dion-web/ui';
import { theme } from 'core/theme';
import { Global } from '@emotion/react';
import { GlobalStyle } from 'core/styles/global-style';

import 'material-icons/iconfont/material-icons.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import 'react-toastify/dist/ReactToastify.css';
import 'core/styles/tailwind.output.css';
import { RouterProvider } from 'react-router-dom';
// import { dionWebContainerRouter } from './dionWebContainer/router';

const rootEl = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootEl);

/*root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <RouterProvider router={dionWebContainerRouter} />
    </ThemeProvider>
  </React.StrictMode>
);*/

const AppLazy = lazy(() => import('./dionWebContainer/app'));
// const AppLazy = lazy(() => import('./dionWebContainer/router'));

// const url = process.env.NODE_ENV === 'development' ? '/envs.json' : '/admin/envs.json';
const envUrl = '/platform/envs.json';

root.render(
  // <React.StrictMode>

  <DionThemeProvider
    theme={{
      dionAdminPalette: theme,
    }}
    modeStorageKey='dion-web-admin-theme-mode'
    defaultMode={'light'}
  >
    <Global styles={GlobalStyle} />
    <DionEnvServiceWrapper lazyChildren={AppLazy} url={envUrl} />
  </DionThemeProvider>
  // </React.StrictMode>
);
